/**
 * description: 试用期员工跟踪考核指标
 * author: bql
 * 2023/7/18 11:16
 */
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class ProbationAssessmentItemApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'probation-assessment-item'
    }

}